import { useCurrency } from "../currency/Currency";
import React from "react";
import { Link } from "react-router-dom";
const ShopProduct = ({ title, price, image, ID, option }: any) => {
  const { money } = useCurrency();
  const quote = option?.length > 0 || !Number.isFinite(price) || price <= 0;
  return (
    <article className="w-[191px] h-fit flex items-center flex-col mobile:w-full">
      <Link to={`/product/${encodeURIComponent(ID)}`}>
        <img
          className="w-44 h-52 object-contain"
          src={image || "/catalog/placeholder.svg"}
          alt={title}
        />
      </Link>
      <h3 className="text-center">
        <Link to={`/product/${encodeURIComponent(ID)}`}>{title}</Link>
      </h3>
      <p className="font-bold my-2">{quote ? "Request a quote" : money(price)}</p>
      <Link
        className="rounded-full px-5 py-2 bg-[#b71827] text-white"
        to={`/product/${encodeURIComponent(ID)}`}
      >
        View item
      </Link>
    </article>
  );
};
export default ShopProduct;
